
export class Region {

  constructor(
    public id: number,
    public title: string,
  ) {}
}
